<template>
  <div class="" style="height: 89.5vh;">
    <spinner-round :isLoading="loading" v-if="!loading"></spinner-round>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">
        <h1 class="title is-3">
          <router-link :to="{name: 'PoleList'}"
                       class="has-text-weight-black is-underline is-dotted">Pôles</router-link>
          <span class="is-margin-left-xsmall has-text-weight-medium has-text-black">{{p.name}}</span>
        </h1>
      </span>
      <div class="dropdown-item" slot="dropdown-content">
        <a @click="deletePole" class="has-text-danger">
          <span class="icon"><i class="fal fa-trash"></i></span>
          <span>Supprimer</span>
        </a>
      </div>
    </sticky>
    <div class="columns has-bg-light is-padding-left-on-btn-actions is-padding-right-on-btn-actions has-stickyColumn has-stickyColumn--left" v-if="!loading">
      <div class="column is-4 is-3-fullhd is-paddingless-left is-paddingless-right">
        <div class="card is-white">
          <div class="columns is-vcentered">
            <div class="column"></div>
            <div class="column is-narrow has-text-right is-size-5 is-margin-right-smallxx">
              <span v-if="p.created_on" class="is-pulled-right tooltip is-tooltip-right"
                    :data-tooltip="createdOnTooltip">
                  <i class="fal fa-info-circle fa-lg has-text-grey"></i>
              </span>
            </div>
          </div>
          <div class="is-padding-left is-padding-right is-padding-bottom has-text-centered">
            <figure class="image is-128x128 is-margin-auto has-picto">
              <div class="is-border is-border-circle is-clipped">
                <img v-if="p.picture" :src="p.picture|avatarBig">
                <div v-else class="has-bg-brand has-text-white is-size-1" style="width:126px; line-height:126px">
                  {{p.name[0] | cap}}{{p.name[1] | cap}}
                </div>
              </div>
            </figure>

            <div class="title is-3 is-margin-top-xsmall is-marginless-bottom"><b>{{p.name}}</b></div>
          </div>
          <div class="columns is-multiline is-border-top">
            <div class="column is-6 is-border-right is-border-dashed columns is-column is-space-between">
              <div class="has-text-grey is-size-6">Membre(s) du pôle</div>
              <div class="is-margin-top-xsmall is-size-4">
                <span>{{p.users.length}}</span>
              </div>
            </div>
            <div class="column is-6 is-border-dashed columns is-column is-space-between">
              <div class="has-text-grey is-size-6">Utilisateur(s) ayant accès au pôle</div>
              <div class="is-margin-top-xsmall is-size-4">
                <span>{{p.accesses.length}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-8 is-9-fullhd is-paddingless-right">
        <div class="has-bg-white is-border is-padding-bottom-xsmall">

            <div class="tabs is-separatedUnderlined is-marginless-bottom">
              <ul class="has-text-weight-medium">
                <li :class="{'is-active': panel === 'MEMBERS'}"><a @click="changePanel(PANELS.MEMBERS)">Membres</a></li>
                <li :class="{'is-active': panel === 'INFOS'}"><a @click="changePanel(PANELS.INFOS)">Informations</a></li>
                <!--<li :class="{'is-active': panel === 'STATS'}"><a @click="changePanel(PANELS.STATS)">Statistiques</a></li> -->
                <li :class="{'is-active': panel === 'SHAREDUSERS'}"><a @click="changePanel(PANELS.SHAREDUSERS)">Accès</a></li>
              </ul>
            </div>
            <component :is="panelComponent" :pole="pole" :shared-users="sharedUsers" @editPole="val => pole = val"></component>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'
  import moment from 'moment'
  import MembersPanel from './PolePanel/MembersPanel'
  import SharedUsersPanel from './PolePanel/SharedUsersPanel'
  import InfosPanel from './PolePanel/InfosPanel'

  const PANELS = Object.freeze({
    MEMBERS: 'MEMBERS',
    INFOS: 'INFOS',
    SHAREDUSERS: 'SHAREDUSERS'
  })

  export default {
    name: 'PoleVue',
    mixins: [DefaultValues],
    data () {
      return {
        pole: {},
        loading: false,
        userLoading: false,
        users: [],
        filterName: null,
        showSearch: false,
        tab: 'users',
        poleParent: {},
        poles: [],
        addPoleParent: false,
        newName: false,
        sharedUsers: [],
        panel: PANELS.MEMBERS,
        PANELS: PANELS
      }
    },
    components: {MembersPanel, SharedUsersPanel, InfosPanel},
    computed: {
      polePk () {
        return this.$route.params.id
      },
      p () {
        return this.pole
      },
      filteredUsers () {
        let poleUsersPk = this.p.users.map(e => e.user)
        return this.users.filter(el => {
          if (!poleUsersPk.includes(el.pk)) {
            return el
          }
        })
      },
      filteredGroup () {
        let poleUsersPk = this.p.users.map(e => e.user)
        return this.managers.filter(el => {
          if (!poleUsersPk.includes(el.pk)) {
            return el
          }
        })
      },
      filteredPolesParents () {
        return this.poles.filter(el => el.pk !== this.p.pk)
      },
      managers () {
        return this.users.filter(x => x.is_manager)
      },
      panelComponent () {
        const components = {
          [PANELS.MEMBERS]: 'MembersPanel',
          [PANELS.INFOS]: 'InfosPanel',
          [PANELS.SHAREDUSERS]: 'SharedUsersPanel'
        }
        return components[this.panel]
      },
      createdOnTooltip () {
        let date = moment(this.p.created_on).format('DD/MM/YYYY')
        return `Créé le ${date}`
      }
    },
    methods: {
      changePanel (panel) {
        this.panel = panel
      },
      getPole () {
        this.loading = true
        this.$api.poleService.getOne(this.polePk).then(r => {
          this.loading = false
          this.pole = r.data
          this.poleParent = {
            pk: this.p.parent,
            name: this.p.parent_name
          }
        })
      },
      submit (pole) {
        this.loading = true
        this.$api.poleService.post(pole).then(r => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Le pôle a été créé.'
          })
          this.$router.replace({name: 'PoleVue', params: {id: r.data.pk}})
          this.initPoleVue()
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la création du pôle.'
          })
        })
      },
      initPoleVue () {
        this.getPole()
        this.getSharedUser()
      },
      deletePole () {
        return this.$swal({
          title: 'Suppression',
          text: 'Êtes vous sûr de supprimer le pôle',
          confirmButtonText: 'Supprimer'
        }).then(r => {
          if (r.value) {
            this.$api.poleService.delete(this.pole.pk).then(r => {
              this.getPoles()
              this.$notify({
                type: 'is-success',
                text: 'Pôle supprimé'
              })
              this.$router.push({name: 'PoleList'})
            })
          }
        })
      },
      getPoles (page = 1) {
        this.$api.poleService.get().then(res => {
          this.$store.commit('setPoles', { poles: res.data.items })
          if (res.data.page < res.data.pages) {
            page++
            this.getPoles(page)
          }
        })
      },
      getSharedUser () {
        this.$api.poleService.getAllSharedUsers(this.polePk).then(r => {
          this.sharedUsers = r.data
        })
      }
    },
    created () {
      this.initPoleVue()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pole/PoleVue.vue